import { cn } from '#components/utils.js'

export function FieldGroup({ className, ...props }) {
  return (
    <div
      className={cn('flex w-full flex-col gap-6', className)}
      data-slot='field-group'
      {...props}
    />
  )
}

export function Field({ className, invalid = false, ...props }) {
  return (
    <div
      className={cn(
        'group/field flex w-full flex-col gap-2',
        invalid && 'text-destructive',
        className,
      )}
      data-invalid={invalid || undefined}
      data-slot='field'
      role='group'
      {...props}
    />
  )
}

export function FieldLabel({ className, ...props }) {
  return (
    <label
      className={cn('w-fit text-sm font-medium leading-snug', className)}
      data-slot='field-label'
      {...props}
    />
  )
}

export function FieldDescription({ className, ...props }) {
  return (
    <p
      className={cn('text-sm leading-6 text-muted-foreground', className)}
      data-slot='field-description'
      {...props}
    />
  )
}

export function FieldError({ className, ...props }) {
  return (
    <p
      className={cn('text-sm leading-6 text-destructive', className)}
      data-slot='field-error'
      role='alert'
      {...props}
    />
  )
}
